/**
 * LayoutModeContext — lets pages opt into a full-bleed main content area.
 *
 * AppLayout's default wrapper constrains children to max-w-[840px] mx-auto
 * for readability on long-form pages. Cockpit-style pages (Inbox cockpit)
 * need the full viewport minus the sidebar gutter.
 *
 * A page calls setFullBleed(true) on mount and setFullBleed(false) on
 * unmount to toggle the wrapper.
 */

import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const LayoutModeContext = createContext({
  fullBleed: false,
  setFullBleed: () => {},
});

export function LayoutModeProvider({ children }) {
  const [fullBleed, setFullBleedState] = useState(false);

  const setFullBleed = useCallback((next) => {
    setFullBleedState(Boolean(next));
  }, []);

  const value = useMemo(() => ({ fullBleed, setFullBleed }), [fullBleed, setFullBleed]);

  return (
    <LayoutModeContext.Provider value={value}>
      {children}
    </LayoutModeContext.Provider>
  );
}

export function useLayoutMode() {
  return useContext(LayoutModeContext);
}

export default LayoutModeContext;
